<template>
  <div>
    <ValidationProvider
      v-if="useValidation"
      :mode="mode"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ valid, errors, classes }"
    >
      <v-text-field
        :type="type"
        :append-icon="appendIcon"
        :clearable="clearable"
        :hide-details="hideDetails"
        :hint="hint"
        :maxLength="maxLength"
        :outlined="outlined"
        :prepend-icon="prependIcon"
        v-model="innerValue"
        v-bind="$attrs"
        v-on="$listeners"
        :error-messages="errors"
        :success="valid"
        :class="classes"
        :persistent-hint="persistentHint"
        ref="appInput"
      />
    </ValidationProvider>

    <!-- ===== If validation is disabled ===== -->
    <v-text-field
      v-else
      :type="type"
      :append-icon="appendIcon"
      :clearable="clearable"
      :hide-details="hideDetails"
      :hint="hint"
      :maxLength="maxLength"
      :outlined="outlined"
      :prepend-icon="prependIcon"
      v-model="innerValue"
      v-bind="$attrs"
      v-on="$listeners"
      :persistent-hint="persistentHint"
      ref="appInput"
    />
  </div>
</template>

<script>
/* eslint-disable sort-imports */ // <- need to keep this specific order
import { ValidationProvider } from "vee-validate";
import Cleave from "cleave.js";
import "cleave.js/dist/addons/cleave-phone.us";

export default {
  name: "AppInput",
  components: {
    ValidationProvider
  },

  props: {
    appendIcon: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    maxLength: {
      type: [String, Number]
    },
    mode: {
      type: String,
      default: "eager"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String
    },
    rules: {
      type: [String, Object],
      default: "required"
    },
    type: {
      type: [String, null]
    },
    useValidation: {
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Object, Number, Array]
    }
  },

  data() {
    return {
      cleave: undefined,
      fill: false,
      innerValue: this.value
    };
  },

  watch: {
    innerValue: function(newVal) {
      this.emitNewValue(newVal);
    },
    value: function(newVal) {
      this.setNewValue(newVal);
    }
  },

  methods: {
    emitNewValue(newVal) {
      this.$emit("input", newVal);
    },
    setNewValue(newVal) {
      this.innerValue = newVal;
    },
    onValueChanged({ target }) {
      this.$nextTick(() => {
        this.setNewValue(target.value);
        // best practice is to emit the raw value instead of masked value
        // for now call center works with masked values
        // this.emitNewValue(target.rawValue);
      });
    }
  },

  computed: {
    delimiter() {
      if (this.type === "phone") {
        return "-";
      } else if (this.type === "creditCard") {
        return " ";
      } else {
        return "";
      }
    }
  },

  mounted() {
    if (this.type === "creditCard" || this.type === "phone") {
      this.cleave = new Cleave(this.$el.querySelector("input"), {
        creditCard: this.type === "creditCard",
        delimiter: this.delimiter,
        phone: this.type === "phone",
        phoneRegionCode: "US",
        onValueChanged: this.onValueChanged.bind(this)
      });

      this.cleave.setRawValue(this.value);
    }
  }
};
</script>

<style scoped>
.v-input.is-valid .v-input__slot {
  border: 1px solid #38c172;
}
.v-input.is-invalid .v-input__slot {
  border: 1px solid #c8102e;
}
</style>
